import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { getTeam, resolveImg } from '../lib/api';
import { useSettings } from '../lib/SettingsContext';

import { useLang } from '../lib/i18n';
export default function QuienesSomos() {
  const { ui } = useLang();
  const { settings } = useSettings();
  const [team, setTeam] = useState([]);
  useEffect(() => { getTeam().then(setTeam).catch(() => {}); }, []);
  const heroImg = resolveImg(settings.hero_images?.[1] || settings.hero_images?.[0] || '');

  return (
    <div>
      <section className="relative h-[55vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 gd-hero-bg" style={{ backgroundImage: `url(${heroImg})` }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(13,13,14,0.6), rgba(13,13,14,0.95))' }} />
        <div className="relative z-10 text-center px-6">
          <div className="gd-eyebrow mb-3">{ui('about.eyebrow')}</div>
          <h1 className="font-script text-[#c9a063] text-5xl md:text-7xl leading-none mb-2">{ui('about.title')}</h1>
          <p className="font-serif-display text-white text-2xl md:text-3xl mt-4">{ui('about.sub')}</p>
        </div>
      </section>

      <section className="py-24 px-6 md:px-10 bg-[#0d0d0e]">
        {settings.quienes_intro && (
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-white/75 text-lg md:text-xl leading-relaxed">{settings.quienes_intro}</p>
          </div>
        )}
        <div className="max-w-6xl mx-auto mt-20 space-y-20">
          {team.map((p, i) => (
            <div key={p.id} className={`grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center ${i % 2 === 1 ? 'md:[direction:rtl]' : ''}`}>
              <div className="md:[direction:ltr] flex justify-center">
                <div className="relative aspect-[4/5] overflow-hidden bg-[#1a1a1d] w-[70%] max-w-[340px]">
                  {p.photo ? (
                    <img src={resolveImg(p.photo)} alt={p.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-[#c9a063]/40"><Users size={64} /></div>
                  )}
                  <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
                </div>
              </div>
              <div className="md:[direction:ltr]">
                <div className="text-[#c9a063] gd-eyebrow mb-3">{p.role}</div>
                <h2 className="font-serif-display text-3xl md:text-4xl text-white mb-2">{p.name}</h2>
                <div className="w-12 h-px bg-[#c9a063] my-5" />
                <p className="text-white/70 text-lg leading-relaxed">{p.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
